exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{padding:18pt}.footer,.header,.line_1,.line_2,.number_1,.number_2{text-align:center}.header div:nth-child(2){font-size:22pt}div.logo{margin-top:36pt}.header div:nth-child(3){margin:13pt 0 49pt}.method_1 div:first-child,.method_2 div:first-child{margin-bottom:15pt}.number_1,.number_2{border-bottom:2pt dashed #2399fa;display:flex;display:-webkit-flex;flex-wrap:wrap;margin-bottom:16pt}.number_1>div,.number_2>div{height:7px;width:33.3%}.line_1,.line_2{display:flex;display:-webkit-flex;flex-wrap:wrap;font-size:26pt}.line_1 div,.line_2 div{width:33%}.line_1 p,.line_2 p{margin-top:5pt;margin-bottom:15pt}.line_1{margin-bottom:24pt}.footer{margin-top:48pt;color:#999;font-size:20pt;left:0;right:0;bottom:20px}.footer p{margin-top:5pt;margin-bottom:5pt}.phone{color:#2399fa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67286e27","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 12
// module chunks = 0